import request, { serviceV2 } from '@/utils/request'

const prefix = '/django_rest/company/talent-pool'
const talentPoolV2Prefix = '/talent-pool'

export default {
  getResumeDownloadUrl (candidateId, params) {
    return serviceV2.get(`${talentPoolV2Prefix}/${candidateId}/resume-download/`, { params })
  },
  getCompanyTalentCandidateList (params) {
    return request.get(`${prefix}/`, { params })
  },
  getTalentCandidateIdList (params) {
    return request.get(`${prefix}/all-talent-ids/`, { params })
  },
  getTalentCandidateInfo (candidateId) {
    return request.get(`${prefix}/${candidateId}/profile/`)
  },
  getTalentFilterParentGroup () {
    return serviceV2.get(`${talentPoolV2Prefix}/group/parent-group/`)
  },
  getTalentFilterGroup (groupId) {
    return serviceV2.get(`${talentPoolV2Prefix}/group-filter/${groupId}/`)
  },
  createTalentFilterGroup (params) {
    return serviceV2.post(`${talentPoolV2Prefix}/group-filter/`, params)
  },
  updateTalentFilterGroup (params) {
    return serviceV2.put(`${talentPoolV2Prefix}/group-filter/${params.group_id}/`, params)
  },
  searchTalentFilterGroup (params) {
    return serviceV2.get(`${talentPoolV2Prefix}/group/`, { params })
  },
  searchTalentFilterGroupList (params) {
    return serviceV2.get(`${talentPoolV2Prefix}/group-list/`, { params })
  },
  updateTalentFilterGroupInfo (group) {
    return serviceV2.put(`${talentPoolV2Prefix}/group/${group.id}/`, group)
  },
  deleteTalentFilterGroup (params) {
    return serviceV2.delete(`${talentPoolV2Prefix}/group/${params.id}/`, { params })
  },
  createTalentPoolComment (params) {
    return serviceV2.post(`${talentPoolV2Prefix}/candidate/comment/`, params)
  },
  createTalentCandidateShareLinkCode (params) {
    return request.post(`${prefix}/candidate/share-link/`, params)
  },
  exportTalentCandidateProfilePdf (params) {
    return request.post(`${prefix}/candidate/export-pdf/`, params)
  },
  getExportTalentCandidateProfilePdfTaskStatus (params) {
    return request.get(`${prefix}/candidate/export-pdf/`, { params })
  },
  getTalentCandidateExportExcelFieldInfo () {
    return request.get(`${prefix}/candidate/export-excel/`)
  },
  createTalentCandidateExportExcelInfoTask (params) {
    return request.post(`${prefix}/candidate/export-excel/`, params)
  },
  copyTalentCandidate (params) {
    return request.post(`${prefix}/copy-candidate/apply-job/`, params)
  },
  getTalentCandidateBaseInfo (candidateId) {
    return request.get(`${prefix}/${candidateId}/base-info/`)
  },
  getTalentCandidateResumeInfo (candidateId) {
    return request.get(`${prefix}/${candidateId}/resume/`)
  },
  getTalentCandidateActivityInfo (candidateId) {
    return request.get(`${prefix}/${candidateId}/activity/`)
  },
  getTalentCandidateTagInfo (params) {
    return request.get(`${prefix}/${params.candidateId}/tag/`, { params })
  },
  getTalentDuplicateCandidateList (candidateId) {
    return request.get(`${prefix}/${candidateId}/duplicate-candidate/`)
  },
  getTalentCandidateSurveyInfo (candidateId) {
    return request.get(`${prefix}/${candidateId}/survey/`)
  },
  getTalentDuplicateCandidateIds (params) {
    return request.get(`${prefix}/duplicate-candidate/`, { params })
  },
  getTalentResumeInfo (candidateId) {
    return request.get(`${prefix}/candidate/${candidateId}/resume/`)
  },
  updateTalentResumeInfo (params) {
    return request.post(`${prefix}/candidate/${params.candidateId}/resume/`, params)
  },
  updateTalentResumePhoto (candidateId, photo) {
    const formData = new FormData()
    formData.append('photo', photo)
    return request.post(`${prefix}/candidate/${candidateId}/photo/`, formData)
  }
}
